// ios
export const contentJson = {
    images: [
        {
            idiom: "iphone",
            size: "20x20",
            scale: "2x",
            filename: "Icon-App-20x20@2x.png"
        },
        {
            idiom: "iphone",
            size: "20x20",
            scale: "3x",
            filename: "Icon-App-20x20@3x.png"
        },
        {
            idiom: "iphone",
            size: "29x29",
            scale: "1x",
            filename: "Icon-App-29x29@1x.png"
        },
        {
            idiom: "iphone",
            size: "29x29",
            scale: "2x",
            filename: "Icon-App-29x29@2x.png"
        },
        {
            idiom: "iphone",
            size: "29x29",
            scale: "3x",
            filename: "Icon-App-29x29@3x.png"
        },
        {
            idiom: "iphone",
            size: "40x40",
            scale: "1x",
            filename: "Icon-App-40x40@1x.png"
        },
        {
            idiom: "iphone",
            size: "40x40",
            scale: "2x",
            filename: "Icon-App-40x40@2x.png"
        },
        {
            idiom: "iphone",
            size: "40x40",
            scale: "3x",
            filename: "Icon-App-40x40@3x.png"
        },
        {
            idiom: "iphone",
            size: "57x57",
            scale: "1x",
            filename: "Icon-App-57x57@1x.png"
        },
        {
            idiom: "iphone",
            size: "57x57",
            scale: "2x",
            filename: "Icon-App-57x57@2x.png"
        },
        {
            idiom: "iphone",
            size: "60x60",
            scale: "1x",
            filename: "Icon-App-60x60@1x.png"
        },
        {
            idiom: "iphone",
            size: "60x60",
            scale: "2x",
            filename: "Icon-App-60x60@2x.png"
        },
        {
            idiom: "iphone",
            size: "60x60",
            scale: "3x",
            filename: "Icon-App-60x60@3x.png"
        },
        {
            idiom: "iphone",
            size: "76x76",
            scale: "1x",
            filename: "Icon-App-76x76@1x.png"
        },
        {
            idiom: "ipad",
            size: "20x20",
            scale: "1x",
            filename: "Icon-App-20x20@1x.png"
        },
        {
            idiom: "ipad",
            size: "20x20",
            scale: "2x",
            filename: "Icon-App-20x20@2x.png"
        },
        {
            idiom: "ipad",
            size: "29x29",
            scale: "1x",
            filename: "Icon-App-29x29@1x.png"
        },
        {
            idiom: "ipad",
            size: "29x29",
            scale: "2x",
            filename: "Icon-App-29x29@2x.png"
        },
        {
            idiom: "ipad",
            size: "40x40",
            scale: "1x",
            filename: "Icon-App-40x40@1x.png"
        },
        {
            idiom: "ipad",
            size: "40x40",
            scale: "2x",
            filename: "Icon-App-40x40@2x.png"
        },
        {
            size: "50x50",
            idiom: "ipad",
            filename: "Icon-Small-50x50@1x.png",
            scale: "1x"
        },
        {
            size: "50x50",
            idiom: "ipad",
            filename: "Icon-Small-50x50@2x.png",
            scale: "2x"
        },
        {
            idiom: "ipad",
            size: "72x72",
            scale: "1x",
            filename: "Icon-App-72x72@1x.png"
        },
        {
            idiom: "ipad",
            size: "72x72",
            scale: "2x",
            filename: "Icon-App-72x72@2x.png"
        },
        {
            idiom: "ipad",
            size: "76x76",
            scale: "1x",
            filename: "Icon-App-76x76@1x.png"
        },
        {
            idiom: "ipad",
            size: "76x76",
            scale: "2x",
            filename: "Icon-App-76x76@2x.png"
        },
        {
            idiom: "ipad",
            size: "76x76",
            scale: "3x",
            filename: "Icon-App-76x76@3x.png"
        },
        {
            idiom: "ipad",
            size: "83.5x83.5",
            scale: "2x",
            filename: "Icon-App-83.5x83.5@2x.png"
        },
        {
            size: "1024x1024",
            idiom: "ios-marketing",
            filename: "ItunesArtwork@2x.png",
            scale: "1x"
        }
    ],
    info: {
        version: 1,
        author: "clss.hk"
    }
};

// android
export const androidIcons = [
    {
        size: 72,
        filename: "android/mipmap-hdpi/ic_launcher.png"
    },
    {
        size: 36,
        filename: "android/mipmap-ldpi/ic_launcher.png"
    },
    {
        size: 48,
        filename: "android/mipmap-mdpi/ic_launcher.png"
    },
    {
        size: 96,
        filename: "android/mipmap-xhdpi/ic_launcher.png"
    },
    {
        size: 144,
        filename: "android/mipmap-xxhdpi/ic_launcher.png"
    },
    {
        size: 192,
        filename: "android/mipmap-xxxhdpi/ic_launcher.png"
    },
    {
        size: 512,
        filename: "android/playstore-icon.png"
    }
];



// WEBPACK FOOTER //
// ./src/config.js